module.exports = __webpack_public_path__ + "static/media/bg-certificate.3a91c8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-certificate.png
// module id = 991
// module chunks = 0